/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Controller, useFormContext } from "react-hook-form";
import { Label, Select } from "@nordcloud/gnui";
import { FormGroup } from "~/components";
import { FormField } from "../formConfig";

type RegionOption = {
  label: string;
  value: string;
};

type Props = {
  options: RegionOption[];
};

export function AccountRegionsSelect({ options }: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={FormField.regions}
      render={({ field: { onChange, value } }) => {
        return (
          <FormGroup error={errors[FormField.regions]}>
            <Label name="Select Regions" required />
            <Select
              isMulti
              onChange={onChange}
              value={value}
              placeholder="Select Regions"
              options={options}
              isError={errors[FormField.regions] != null}
            />
          </FormGroup>
        );
      }}
    />
  );
}
